(function() {
    const originalFetch = window.fetch;
    
    window.fetch = function(...args) {
    const [url, options] = args;
    
    if (url.includes('/cart/add')) {
        return originalFetch.apply(this, args).then(response => {
        if (response.ok) {
            response.clone().json().then(data => {
            _learnq.push(['track', 'Added to Cart', {
                '$value': data.final_price / 100,
                'AddedItemProductName': data.product_title,
                'AddedItemProductID': data.product_id,
                'AddedItemSKU': data.sku || '',
                'AddedItemPrice': data.final_price / 100,
                'AddedItemQuantity': data.quantity,
                'ItemNames': [data.product_title],
                'CheckoutURL': window.location.origin + '/checkout',
                'Items': [{
                'ProductID': data.product_id,
                'SKU': data.sku || '',
                'ProductName': data.product_title,
                'Quantity': data.quantity,
                'ItemPrice': data.final_price / 100,
                'RowTotal': (data.final_price * data.quantity) / 100,
                'ProductURL': window.location.origin + data.url,
                'ImageURL': data.image
                }]
            }]);
            }).catch(() => {});
        }
        return response;
        });
    }
    
    return originalFetch.apply(this, args);
    };
})();